/**
 * Helpers for externally-sourced events (e.g. Mobilize live proxy).
 * Defaults are permissive so native events behave unchanged.
 */

export function isExternalEvent(event) {
  if (!event) return false;
  if (event.is_external === true) return true;
  if (event.source && event.source !== 'civixthread') return true;
  return Boolean(event.external_url);
}

export function getExternalUrl(event) {
  if (!event) return null;
  return event.external_url || null;
}
